module.exports = "/_next/static/images/thumb-grid-placeholder-cb5461dabd47700b56135fa6d2b8031a.svg";